export default function SectionEyebrow({ children, color = "#e47a6a" }) {
    return (
        <p
            className="font-sans text-xs uppercase tracking-[0.3em] font-semibold mb-5"
            style={{ color }}
        >
            <span className="inline-block w-8 h-px mr-3 align-middle" style={{ background: color }} />
            {children}
        </p>
    );
}
